import React, { useState, useEffect } from "react";
import OptionBox from "../../components/OptionBox/OptionBox";
import { connect } from "react-redux";
import {
  getMeters,
  meterReadingsByDay,
} from "../../redux/actions/meter.actions";
import Loader from "../../components/Loader";
import l10n from "../../localization";
import ChangeLayoutButton from "./_components/ChangeLayoutButton";
import GraphList from "./_components/GraphList";
import TableList from "./_components/TableList";
import moment from "moment";
import * as Styled from "./reports.styles";

function Reports(props) {
  const [currentDisplay, setCurrentDisplay] = useState("graph");
  const [startDate, setStartDate] = useState(
    moment().startOf("year").format("YYYY-MM-DD")
  );

  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [meterSiteCode, setMeterSiteCode] = useState("all");
  const [meterCode, setMeterCode] = useState("all");

  useEffect(() => {
    if (!props.meters.loaded) props.getMeters();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    props.meterReadingsByDay({
      meterSiteCode: meterSiteCode,
      meterCode: meterCode,
      dateFrom: startDate,
      dateTo: endDate,
    });

    //eslint-disable-next-line
  }, [meterSiteCode, meterCode, startDate, endDate]);

  const changeDisplay = (newDisplay) => {
    setCurrentDisplay(newDisplay);
  };

  if (props.meters.loading) return <Loader />;

  const generateMeters = () => {
    const filteredMeters = props.meters.result.filter(
      (meter) => meter.meterSiteCode === meterSiteCode
    );
    if (filteredMeters.length > 0) {
      const targetMeter = filteredMeters[0];
      return targetMeter.userMeters.map((userMeter) => {
        return {
          slug: userMeter.meterCode,
          value: userMeter.meterCode,
        };
      });
    }

    return [];
  };

  return (
    <div>
      <Styled.Filters>
        <Styled.FilterOptions>
          <Styled.FilterItem>
            <span>{l10n.reports.site_address}</span>
            <OptionBox
              options={[
                {
                  slug: "all",
                  value: l10n.reports.allMeasurementPoints,
                },
                ...props.meters.result.map((meter) => {
                  return {
                    slug: meter.meterSiteCode,
                    value: `${meter.siteAddress}`,
                  };
                }),
              ]}
              selected={meterSiteCode}
              onSelect={(option) => {
                setMeterSiteCode(option.slug);
                setMeterCode("all");
              }}
            />
          </Styled.FilterItem>
          <Styled.FilterItem>
            <span>{l10n.reports.meter}</span>
            <OptionBox
              options={[
                {
                  slug: "all",
                  value: l10n.reports.allMeters,
                },
                ...generateMeters(),
              ]}
              selected={meterCode}
              onSelect={(option) => setMeterCode(option.slug)}
            />
          </Styled.FilterItem>
          <Styled.RangeFilter>
            <Styled.FilterItem>
              <span>{l10n.reports.period_from} </span>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />{" "}
            </Styled.FilterItem>
            <Styled.FilterItem>
              <span>{l10n.reports.perod_to} </span>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </Styled.FilterItem>
          </Styled.RangeFilter>
        </Styled.FilterOptions>
        <Styled.FilterSwitch>
          <ChangeLayoutButton
            display="graph"
            label={l10n.reports.chart}
            onChangeDisplay={changeDisplay}
            currentDisplay={currentDisplay}
          />
          <Styled.FilterSpacer />
          <ChangeLayoutButton
            display="table"
            label={l10n.reports.table}
            onChangeDisplay={changeDisplay}
            currentDisplay={currentDisplay}
          />
        </Styled.FilterSwitch>
      </Styled.Filters>
      <>
        {props.meters.meterReadingsByDay.loading ? (
          <Loader />
        ) : (
          <>
            {currentDisplay === "graph" && (
              <GraphList
                meterSiteCode={meterSiteCode}
                meterCode={meterCode}
                startDate={startDate}
                endDate={endDate}
              />
            )}

            {currentDisplay === "table" && (
              <TableList
                meterSiteCode={meterSiteCode}
                meterCode={meterCode}
                startDate={startDate}
                endDate={endDate}
              />
            )}
          </>
        )}
      </>
    </div>
  );
}

export default connect(({ meters }) => ({ meters }), {
  getMeters,
  meterReadingsByDay,
})(Reports);
